<template>
  <div v-if="visible" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <!-- 关闭按钮 -->
      <div class="modal-close" @click="closeModal">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="modal-body">
        <!-- 商品信息 -->
        <div class="product-info">
          <h3 class="product-title"><span v-if="goods.owner == 'g'">【自营】</span>{{ goods.skuName }}</h3>
        </div>

        <!-- 价格和折扣信息 -->
        <div class="price-discount-section">
          <!-- 优惠券链接 -->
          <!-- <div class="discount-details" v-if="goods.discount">
            <div class="discount-item" style="align-items: normal;">
              <span class="check-icon" style="white-space: nowrap;">{{ goods.discount }}元券</span>
              <span class="discount-text" style="word-break: break-all;">{{ goods.link }}</span>
            </div>
          </div> -->
          <div v-html="goods.guideText" style="   white-space: pre-wrap;word-break: break-word;"></div>
        </div>

        <!-- 分割线 -->
        <div class="divider"></div>

        <!-- 购买链接 -->
        <div class="purchase-link">
          <span class="link-icon">🛒</span>
          <div class="link-content">
            <div class="link-text">
              <span v-if="!isUserLoggedIn()" class="login-required">
                请先登录后获取推广链接
              </span>
              <span v-else-if="loadingPosition">
                正在获取推广链接...
              </span>
              <span v-else>
                {{ promotionLink || `生成中...` }}
              </span>
            </div>
          </div>
        </div>

        <!-- 推广链接二维码 -->
        <div v-if="combinedQrUrl" style="text-align:center; margin:12px 0 0;">
          <div style="font-weight:bold;margin-bottom:6px;">推广链接二维码：</div>
          <img :src="combinedQrUrl" alt="二维码生成中..." style="width: 260px; height: 300px; object-fit: contain;" />
        </div>

        <div class="position-info" v-if="!loadingPosition && isUserLoggedIn()">
          <span class="position-label">推广位:</span>
          <span class="position-value">{{ getCurrentUserPositionId() }}</span>
        </div>

      </div>
      <div class="modal-footer">
        <div class="action-buttons">
          <button class="copy-link-btn" @click="copyPromotionLink" :disabled="!promotionLink || !isUserLoggedIn()">
            <span class="btn-text">{{ isUserLoggedIn() ? '复制链接' : '请先登录' }}</span>
          </button>
          <button class="save-image-btn" @click="downloadCombinedQr" :disabled="!combinedQrUrl || !isUserLoggedIn()">
            <span class="btn-text">保存图片</span>
          </button>
          <button class="share-earn-btn" @click="handleShareEarn" :disabled="!isUserLoggedIn()">
            <span class="share-text">{{ isUserLoggedIn() ? `复制文案` : '请先登录' }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- 底部操作区 -->
  </div>
</template>

<script>
import { createPromotionLink } from '@/utils/jdApi'
import QRCode from 'qrcode'

export default {
  name: 'ShareEarnModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    goods: {
      type: Object,
      default: () => ({})
    },
    positionId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      positionInfo: null,
      loadingPosition: false,
      promotionLink: null,
      combinedQrUrl: '',
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.goods.itemId) {
        // 检查用户是否已登录
        if (!this.isUserLoggedIn()) {
          this.$message?.warning?.('请先登录后再使用推广功能')
          this.closeModal()
          return
        }
        // 弹窗显示时自动生成推广链接
        this.generatePromotionLink()
      }
    }
  },
  methods: {
    // 检查用户是否已登录
    isUserLoggedIn() {
      const token = localStorage.getItem('token')
      return !!token
    },

    closeModal() {
      this.$emit('close')
    },
    formatPrice(price) {
      if (!price) return '0.00'
      return Number(price).toFixed(2)
    },
    // 生成推广链接
    async generatePromotionLink() {
      if (!this.goods.itemId) return
      try {
        // 获取当前用户的positionId
        const positionId = this.getCurrentUserPositionId()
        if (!positionId) {
          this.promotionLink = '无法生成链接请联系团长'
          return
        }

        const payload = {
          materialId: this.goods.itemId,
          positionId: positionId
        }

        // 调用生成推广链接的API，siteId 和 sceneId 由后端自动获取
        const res = await createPromotionLink(payload)

        // 解析新的返回格式：{ code, link, goodsInfo }
        // 保持向后兼容：优先使用 link 字段，如果没有则使用 data 字段
        if (res && res.code === 200) {
          let linkData = null
          if (res.link) {
            // 新格式：link 字段包含转链结果
            linkData = res.link.data || res.link
          } else if (res.data) {
            // 旧格式：直接使用 data 字段
            linkData = res.data
          }

          if (linkData) {
            // 优先使用shortURL，如果没有则使用clickURL
            this.promotionLink = linkData.shortURL || linkData.clickURL
            // 生成二维码
            if (this.promotionLink) {
              await this.generateCombinedQr(this.promotionLink)
            }
          } else {
            this.promotionLink = '无法生成链接请联系团长'
            this.combinedQrUrl = ''
          }
        } else {
          this.promotionLink = '无法生成链接请联系团长'
          this.combinedQrUrl = ''
        }
      } catch (error) {
        console.error('生成推广链接失败:', error)
        this.promotionLink = '无法生成链接请联系团长'
        this.combinedQrUrl = ''
      }
    },

    // 获取当前用户的推广位ID
    getCurrentUserPositionId() {
      // 从父组件传递的positionId获取
      return this.positionId || this.getUserPositionIdFromStorage()
    },

    // 从localStorage获取用户推广位ID
    getUserPositionIdFromStorage() {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      return user.positionId
    },

    async handleShareEarn() {
      // 如果还没有生成推广链接，则尝试生成一次
      if (!this.promotionLink) {
        await this.generatePromotionLink()
      }

      const promoText = this.buildPromotionText()

      // 复制到剪贴板
      try {
        await navigator.clipboard.writeText(promoText)
        this.$message?.success?.('推广文案已复制')
      } catch (error) {
        // 降级方案
        const textarea = document.createElement('textarea')
        textarea.value = promoText
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message?.success?.('推广文案已复制')
      }
    },

    async generateCombinedQr(clickUrl) {
      try {
        // 生成二维码 dataURL
        const qrDataUrl = await QRCode.toDataURL(clickUrl, { width: 200, margin: 4 })
        // 创建画布，预留下方文字区域
        const canvas = document.createElement('canvas')
        const qrSize = 200
        const textAreaHeight = 20
        canvas.width = qrSize
        canvas.height = qrSize + textAreaHeight
        const ctx = canvas.getContext('2d')
        // 白底
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        // 画二维码
        const img = new Image()
        await new Promise(resolve => {
          img.onload = () => {
            ctx.drawImage(img, 0, 0, qrSize, qrSize)
            resolve()
          }
          img.src = qrDataUrl
        })

        // 在二维码中间添加logo
        const logoImg = new Image()
        await new Promise(resolve => {
          logoImg.onload = () => {
            // 计算logo位置和大小（二维码中心，大小为二维码的1/6，更小避免遮挡）
            const logoSize = qrSize / 6  // 约33px，更小
            const logoX = (qrSize - logoSize) / 2
            const logoY = (qrSize - logoSize) / 2

            // 画白色背景圆形，稍微大一点确保覆盖
            ctx.fillStyle = '#fff'
            ctx.beginPath()
            ctx.arc(qrSize / 2, qrSize / 2, logoSize / 2 + 4, 0, 2 * Math.PI)
            ctx.fill()

            // 画logo
            ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize)
            resolve()
          }
          logoImg.onerror = () => {
            console.warn('Logo图片加载失败，跳过logo添加')
            resolve()
          }
          logoImg.src = require('@/assets/images/qr-logo.png')
        })
        // 画文字（红色、加粗、居中）
        ctx.fillStyle = '#e53935'
        ctx.font = '600 18px Arial'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText('京东扫码', canvas.width / 2, qrSize + textAreaHeight / 2)
        // 输出合成图
        this.combinedQrUrl = canvas.toDataURL('image/png')
      } catch (e) {
        console.error('生成二维码失败', e)
        this.combinedQrUrl = ''
      }
    },

    downloadCombinedQr() {
      if (!this.combinedQrUrl) return
      const a = document.createElement('a')
      a.href = this.combinedQrUrl
      a.download = 'jd-qrcode.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    // 组装推广文案：标题 + 折扣信息(原价/到手价/折扣) + 优惠详情 + 优惠券链接 + 推广链接
    buildPromotionText() {
      const lines = []
      lines.push(`复制下单链接到京东APP，首页搜索框打开`)
      lines.push(`【${this.goods.skuName}】`)
      // if (this.goods.discount) {
      //   lines.push(`【券】减${this.goods.discount}：${this.goods.link}`)
      // }
      if (this.goods.guideText) {
        lines.push(this.goods.guideText)
      }
      if (this.promotionLink) {
        lines.push(`下单链接：${this.promotionLink}`)
      }
      return lines.join('\n')
    },

    // 复制推广链接
    async copyPromotionLink() {
      if (!this.promotionLink) {
        this.$message?.error?.('推广链接未生成')
        return
      }

      try {
        await navigator.clipboard.writeText(this.promotionLink)
        this.$message?.success?.('推广链接已复制到剪贴板')
      } catch (error) {
        // 降级方案
        const input = document.createElement('input')
        input.value = this.promotionLink
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message?.success?.('推广链接已复制到剪贴板')
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 24px;
  max-width: 400px;
  max-height: 75vh;
  position: relative;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease-out;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.modal-body {
  overflow-y: auto;
}

.modal-close {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: rgba(0, 0, 0, 0.1);
}

.modal-close svg {
  color: #666;
  width: 16px;
  height: 16px;
}

.product-info {
  margin-bottom: 10px;
}

.product-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.2;
  margin: 0;
  /* display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; */
}

.price-discount-section {
  margin-bottom: 20px;
}

.discount-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.discount-icon {
  font-size: 16px;
}

.discount-rate {
  color: #ff6b35;
  font-weight: 600;
}

.separator {
  color: #ddd;
  margin: 0 4px;
}

.price-icon {
  font-size: 16px;
}

.current-price {
  color: #333;
  font-weight: 600;
  font-size: 16px;
}

.discount-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.discount-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.check-icon {
  color: #28a745;
  font-weight: bold;
  font-size: 16px;
}

.discount-text {
  color: #28a745;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 10px 0;
  position: relative;
}

.divider::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: repeating-linear-gradient(to right,
      #eee 0px,
      #eee 4px,
      transparent 4px,
      transparent 8px);
}

.purchase-link {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 14px;
}

.link-icon {
  font-size: 16px;
  margin-top: 2px;
}

.link-content {
  flex: 1;
}

.link-text {
  color: #333;
  word-break: break-all;
  margin-bottom: 4px;
}

.position-info {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #666;
}

.position-label {
  font-weight: 500;
}

.position-value {
  color: #28a745;
  font-weight: 600;
}

.login-required {
  color: #dc3545;
  font-style: italic;
}

.goods-details {
  margin: 20px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.details-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.detail-item {
  display: flex;
  margin-bottom: 8px;
  font-size: 13px;
}

.detail-label {
  font-weight: 500;
  color: #666;
  min-width: 60px;
}

.detail-value {
  color: #333;
  flex: 1;
}

.raw-data-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #dee2e6;
}

.raw-data-section h4 {
  margin: 0 0 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

.raw-data {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px;
  font-size: 10px;
  color: #666;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-all;
}

.modal-footer {
  margin-top: 12px;
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 12px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.toggle-details-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.toggle-details-btn:hover {
  background: #5a6268;
}

.copy-link-btn {
  background: #42b983;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
}

.copy-link-btn:hover:not(:disabled) {
  background: #369870;
}

.copy-link-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.report-link {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s ease;
}

.report-link:hover {
  color: #333;
}

.info-icon {
  font-size: 14px;
}

.share-earn-btn {
  background: #42b983;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 4px 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
  flex: 1;
}

.share-earn-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.save-image-btn {
  background: #42b983;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
}

.save-image-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.share-icon {
  font-size: 16px;
  animation: rotate 2s linear infinite;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .modal-content {
    margin: 20px;
    padding: 20px;
    max-width: none;
    width: calc(100% - 40px);
  }

  .modal-footer {
    flex-direction: row;
    gap: 16px;
    align-items: stretch;
  }

  .share-earn-btn {
    flex: 1;
    justify-content: center;
  }

  .report-link {
    justify-content: center;
  }
}

.original-price {
  color: #ccc;
  font-size: 14px;
  text-decoration: line-through;
}

.price-value {
  font-size: 16px;
  font-weight: 600;
  color: #28a745;
}
</style>
